
import { defineComponent } from "vue";

const GHL_APP_BASE_URL = (process.env.VUE_APP_GHL_APP_BASE_URL || "https://app.ai247saas.com").replace(/\/$/, "");

export default defineComponent({
  name: "ai247-instance-detail",
  props: {
    activeInstanceKey: { type: String, default: "" },
    location: { type: Object, default: null },
    connected: { type: Boolean, default: false },
    pendingApplication: { type: Boolean, default: false },
    statusLoaded: { type: Boolean, default: false },
    subscription: { type: Object, default: null },
    trialDaysLeft: { type: Number, default: 0 },
    showPlanButtons: { type: Boolean, default: false },
    submitting: { type: Boolean, default: false },
    refreshing: { type: Boolean, default: false },
    subscribing: { type: Boolean, default: false },
    hasPendingSlots: { type: Boolean, default: false },
    canSignup: { type: Boolean, default: false },
    form: { type: Object, required: true },
    countries: { type: Array, default: () => [] }
  },
  emits: ["refresh", "submit-form", "choose-plan", "activate-another"],
  computed: {
    instanceTitle(): string {
      const accountName = String(this.location?.accountName || "").trim();
      if (accountName) return accountName;
      if (!this.activeInstanceKey) return "AI 24/7 instance";
      const key = String(this.activeInstanceKey);
      if (key.length <= 16) return key;
      return `${key.slice(0, 8)}…${key.slice(-4)}`;
    },
    statusBadge(): string {
      if (this.connected && this.location) return "Active";
      if (this.pendingApplication && this.location) return "Pending";
      if (this.location?.status) {
        return this.location.status === "suspended" ? "Disconnected" : String(this.location.status);
      }
      if (this.hasPendingSlots && !this.location) return "Not activated";
      return "";
    },
    subscriptionStat(): string {
      if (!this.subscription) return "—";
      if (this.subscription.status === "trialing") {
        return `${this.trialDaysLeft}d trial`;
      }
      return this.planLabel(this.subscription.plan) || this.subscription.status;
    },
    locationStat(): string {
      if (!this.location?.status) return "Not set up";
      if (this.location.status === "suspended") return "Disconnected";
      if (this.location.status === "pending_application") return "Pending";
      return String(this.location.status);
    },
    createdStat(): string {
      if (!this.location?.createdAt) return "—";
      const date = new Date(this.location.createdAt);
      if (Number.isNaN(date.getTime())) return "—";
      return date.toLocaleDateString(undefined, { month: "short", day: "numeric", year: "numeric" });
    },
    ghlAppUrl(): string {
      if (!this.location?.locationId) return GHL_APP_BASE_URL;
      return `${GHL_APP_BASE_URL}/v2/location/${this.location.locationId}/dashboard`;
    }
  },
  methods: {
    formatDate(value: string) {
      if (!value) return "";
      const date = new Date(value);
      if (Number.isNaN(date.getTime())) return value;
      return date.toLocaleString();
    },
    planLabel(plan: string) {
      if (plan === "monthly") return "Monthly plan";
      if (plan === "quarterly") return "Quarterly plan";
      if (plan === "yearly") return "1-year access";
      if (plan === "trial") return "Free trial";
      return plan || "";
    }
  }
});
